import {
  Button,
  Dialog,
  Flex,
  Label,
  RadioGroup,
  Text,
} from "@100mslive/react-ui";
import {
  DialogContent,
  DialogRow,
  DialogSelect,
} from "../../primitives/DialogContent";
import React, { useCallback, useState } from "react";

import { MicOffIcon } from "@100mslive/react-icons";
import { ROLES_CONVERT } from "../../common/roles";
import { convertRolesName } from "../../common/utils";
import { useFilteredRoles } from "../../common/hooks";
import { useHMSActions } from "@100mslive/react-sdk";
import { useTranslation } from "react-i18next";
const trackSourceOptions = [
  { label: "lbl_all_sources", value: "" },
  { label: "regular", value: "regular" },
  { label: "screen", value: "screen" },
  { label: "audioplaylist", value: "audioplaylist" },
  { label: "videoplaylist", value: "videoplaylist" },
];
const trackTypeOptions = [
  { label: "lbl_all_devices", value: "" },
  { label: "audio", value: "audio" },
  { label: "video", value: "video" },
];
export const MuteAllModal = ({ onOpenChange }) => {
  const { t } = useTranslation();
  const roles = useFilteredRoles();
  const hmsActions = useHMSActions();
  const [enabled, setEnabled] = useState(false);
  const [trackType, setTrackType] = useState();
  const [selectedRole, setRole] = useState();
  const [selectedSource, setSource] = useState();

  const muteAll = useCallback(async () => {
    await hmsActions.setRemoteTracksEnabled({
      enabled: enabled,
      type: trackType,
      source: selectedSource,
      roles: selectedRole ? [selectedRole] : undefined,
    });
    onOpenChange(false);
  }, [
    selectedRole,
    enabled,
    trackType,
    selectedSource,
    hmsActions,
    onOpenChange,
  ]);

  return (
    <Dialog.Root defaultOpen onOpenChange={onOpenChange}>
      <DialogContent
        title={t("lbl_toggle_all_remote_audio_devices")}
        Icon={MicOffIcon}
      >
        <DialogSelect
          title={t("lbl_roles")}
          options={[
            { label: t("lbl_all_roles"), value: "" },
            ...roles.map(role => ({
              label: t("obj_roles." + ROLES_CONVERT[convertRolesName(role)]),
              value: role,
            })),
          ]}
          selected={selectedRole}
          keyField="value"
          labelField="label"
          onChange={setRole}
        />
        <DialogSelect
          title={t("lbl_track_type")}
          options={trackTypeOptions}
          selected={trackType}
          onChange={setTrackType}
          keyField="value"
          labelField="label"
        />
        <DialogSelect
          title={t("lbl_track_source")}
          options={trackSourceOptions}
          selected={selectedSource}
          onChange={setSource}
          keyField="value"
          labelField="label"
        />
        <DialogRow>
          <Text variant="md">{t("lbl_track_status")}</Text>
          <RadioGroup.Root value={enabled} onValueChange={setEnabled}>
            <Flex align="center" css={{ cursor: "pointer", mr: "$8" }}>
              <RadioGroup.Item
                value={false}
                id="trackDisableRadio"
                css={{ mr: "$4", backgroundColor: "$surfaceDefault" }}
              >
                <RadioGroup.Indicator />
              </RadioGroup.Item>
              <Label htmlFor="trackDisableRadio">{t("lbl_mute")}</Label>
            </Flex>
            <Flex align="center" css={{ cursor: "pointer" }}>
              <RadioGroup.Item
                value={true}
                id="trackEnableRadio"
                css={{ mr: "$4", backgroundColor: "$surfaceDefault" }}
              >
                <RadioGroup.Indicator />
              </RadioGroup.Item>
              <Label htmlFor="trackEnableRadio">{t("lbl_unmute")}</Label>
            </Flex>
          </RadioGroup.Root>
        </DialogRow>
        <DialogRow justify="end">
          <Button variant="primary" onClick={muteAll}>
            {t("lbl_apply")}
          </Button>
        </DialogRow>
      </DialogContent>
    </Dialog.Root>
  );
};
